import "styles/pages/page-single-news.scss";

import "react-image-lightbox/style.css";

import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import { FacebookShareButton } from "react-share";
import Lightbox from "react-image-lightbox";
import $ from "jquery";

import Layout from "components/Layout";
import Seo from "components/Seo";
import SectionHeader from "components/SectionHeader/SectionHeader";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import ContactForm from "components/ContactForm/ContactForm";
import FacebookIcon from "assets/icons/facebook.inline.svg";

const SinglePost = ({ pageContext, data }) => {
	const [recipient, setRecipient] = useState("");
	const pageContent = pageContext.data;
	const seo = pageContext.data.seo;
	const author = pageContext.data.author.node;
	const marketingTeam = data.marketingTeam.edges;
	const isBrowser = typeof window !== "undefined";
	const socialLocation = isBrowser ? window.location.href : null;
	const onReset = () => {
		setRecipient("");
	};

	const [photoIndex, setPhotoIndex] = useState(0);
	const [isLightboxOpen, setIsLightboxOpen] = useState(false);
	const galleryFirst = pageContent?.post?.gallery?.map(
		(item) => item.localFile.publicURL
	);

	const [photoIndexSec, setPhotoIndexSec] = useState(0);
	const [isLightboxOpenSec, setIsLightboxOpenSec] = useState(false);
	const gallerySecond = pageContent?.post?.gallerySecond?.map(
		(item) => item.localFile.publicURL
	);

	useEffect(() => {
		$(".post-main__content iframe").wrap(
			'<div class="embed-container"></div>'
		);
	});

	return (
		<Layout>
			<Seo title={seo.title} description={seo.metaDesc} />
			<SubpageHeader
				title={pageContent.title}
				crumbFirstLabel="Aktualności"
				crumbFirstLink="/aktualnosci"
				location={pageContext.title}
			/>

			<section className="post-main">
				<div className="container">
					<div className="post-main__info-header">
						<div className="author-container">
							<img
								src={author.avatar?.url}
								alt=""
								className="img-fluid author-container__avatar"
							/>
							<div>
								<div className="author-container__name">
									{author.firstName} {author.lastName}
								</div>
								<div className="author-container__date">
									{pageContent.date}
								</div>
							</div>
						</div>
						<div className="socials-container">
							<div className="socials-container__label">
								Udostępnij:
							</div>
							<FacebookShareButton
								url={socialLocation}
								className="socials-container__single-link"
							>
								<FacebookIcon className="socials-container__icon" />
							</FacebookShareButton>
						</div>
					</div>
					<div
						className="post-main__content"
						dangerouslySetInnerHTML={{
							__html: pageContent.content,
						}}
					/>

					{pageContent?.post?.gallery && (
						<div className="post-main__gallery">
							<div className="row">
								{pageContent?.post?.gallery.map(
									(item, index) => (
										<div className="col-sm-3" key={index}>
											<button
												onClick={(e) => {
													e.preventDefault();
													setIsLightboxOpen(true);
													setPhotoIndex(index);
												}}
												className="post-main__gallery-item"
											>
												<img
													src={
														item.localFile.publicURL
													}
													alt=""
												/>
											</button>
										</div>
									)
								)}
							</div>
						</div>
					)}

					{pageContent?.post?.contentAfterGallery && (
						<div
							className="post-main__content--after"
							dangerouslySetInnerHTML={{
								__html: pageContent?.post?.contentAfterGallery,
							}}
						/>
					)}

					{pageContent?.post?.gallerySecond && (
						<div className="post-main__gallery">
							<div className="row">
								{pageContent?.post?.gallerySecond.map(
									(item, index) => (
										<div className="col-sm-3" key={index}>
											<button
												onClick={(e) => {
													e.preventDefault();
													setIsLightboxOpenSec(true);
													setPhotoIndexSec(index);
												}}
												className="post-main__gallery-item"
											>
												<img
													src={
														item.localFile.publicURL
													}
													alt=""
												/>
											</button>
										</div>
									)
								)}
							</div>
						</div>
					)}
				</div>
			</section>

			<section className="post-team">
				<div className="container">
					<SectionHeader
						title="Dział marketingu"
						subtitle="NASZ ZESPÓŁ"
						reversed={true}
					/>
					<div className="row justify-content-center">
						{Object.values(marketingTeam)?.map((node, index) => {
							const person = node.node.singleTeam;
							return (
								<div className="col-md-3" key={index}>
									<TeamPersonTile
										name={person.fullname}
										jobName={person.jobname}
										avatar={person.avatar?.sourceUrl}
										phone={person.phone}
										email={person.email}
										onClick={(e) =>
											setRecipient(
												person.singleTeam.email
											)
										}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</section>
			<span className="anchor" id="formularz"></span>
			<section className="post-contact">
				<ContactForm
					subject="AKTUALNOŚCI"
					selectedEmail={recipient}
					onReset={onReset}
				/>
			</section>

			{pageContent?.post?.gallery && isLightboxOpen && (
				<Lightbox
					mainSrc={galleryFirst[photoIndex]}
					nextSrc={
						galleryFirst[(photoIndex + 1) % galleryFirst.length]
					}
					prevSrc={
						galleryFirst[
							(photoIndex + galleryFirst.length - 1) %
								galleryFirst.length
						]
					}
					onCloseRequest={() => setIsLightboxOpen(false)}
					onMovePrevRequest={() =>
						setPhotoIndex(
							(photoIndex + galleryFirst.length - 1) %
								galleryFirst.length
						)
					}
					onMoveNextRequest={() =>
						setPhotoIndex((photoIndex + 1) % galleryFirst.length)
					}
				/>
			)}

			{pageContent?.post?.gallerySecond && isLightboxOpenSec && (
				<Lightbox
					mainSrc={gallerySecond[photoIndexSec]}
					nextSrc={
						gallerySecond[
							(photoIndexSec + 1) % gallerySecond.length
						]
					}
					prevSrc={
						gallerySecond[
							(photoIndexSec + gallerySecond.length - 1) %
								gallerySecond.length
						]
					}
					onCloseRequest={() => setIsLightboxOpenSec(false)}
					onMovePrevRequest={() =>
						setPhotoIndexSec(
							(photoIndexSec + gallerySecond.length - 1) %
								gallerySecond.length
						)
					}
					onMoveNextRequest={() =>
						setPhotoIndexSec(
							(photoIndexSec + 1) % gallerySecond.length
						)
					}
				/>
			)}
		</Layout>
	);
};

export const query = graphql`
	query {
		marketingTeam: allWpTeam(
			filter: { singleTeam: { marketingTeam: { eq: "true" } } }
		) {
			edges {
				node {
					singleTeam {
						marketingTeam
						email
						fullname
						jobname
						phone
						avatar {
							sourceUrl
						}
					}
				}
			}
		}
	}
`;

export default SinglePost;
